export const products = [
  {
    id: 1,
    name: "VPN Pro",
    description: "Secure your internet connection with military-grade encryption. Browse anonymously and access content from anywhere in the world with lightning-fast speeds.",
    icon: "ri-shield-keyhole-line",
    features: [
      "Military-grade encryption",
      "Global server network",
      "Zero-log policy",
      "Kill switch protection"
    ]
  },
  {
    id: 2,
    name: "Cleaner Plus",
    description: "Optimize your iOS device performance by removing junk files, managing storage, and boosting speed. Keep your device running like new.",
    icon: "ri-brush-line",
    features: [
      "Smart storage analysis",
      "Duplicate file finder",
      "Photo compression",
      "Battery optimization"
    ]
  },
  {
    id: 3,
    name: "Security Suite",
    description: "Comprehensive security solution for iOS devices. Protect your personal data, detect threats, and ensure your privacy is always maintained.",
    icon: "ri-lock-line",
    features: [
      "Real-time threat detection",
      "Privacy scanner",
      "Secure vault",
      "Identity protection"
    ]
  },
  {
    id: 4,
    name: "Performance Booster",
    description: "Enhance your device's performance with intelligent optimization. Manage apps, clear cache, and extend battery life effortlessly.",
    icon: "ri-rocket-line",
    features: [
      "App management",
      "Memory optimization",
      "CPU cooling",
      "Battery saver mode"
    ]
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Development Team",
    role: "iOS Specialists",
    description: "Expert developers with years of experience in creating high-performance iOS applications"
  },
  {
    id: 2,
    name: "Security Team",
    role: "Cybersecurity Experts",
    description: "Dedicated professionals ensuring the highest level of security for all our products"
  },
  {
    id: 3,
    name: "Design Team",
    role: "UX/UI Designers",
    description: "Creative minds crafting intuitive and beautiful user experiences"
  }
];
